import { Component, input, model } from '@angular/core';
import { outputFromObservable, toObservable } from '@angular/core/rxjs-interop';
import { debounce as debounceBy, distinctUntilChanged, map, timer } from 'rxjs';
import { JunoInput } from '../juno-input/juno-input';

@Component({
  selector: 'dss-libs-ui-search',
  imports: [JunoInput],
  templateUrl: './search.component.html',
  styleUrl: './search.component.css',
})
export class SearchComponent {
  query = model<string>('');
  debounce = input(500);
  readonly appliedClasses = input('');

  readonly searchValue = outputFromObservable(
    toObservable(this.query).pipe(
      map((q) => q.trim()),
      debounceBy(() => timer(this.debounce())),
      distinctUntilChanged()
    )
  );
}
